import { Box, Container } from "@mui/material";
import Songs from "./Songs";
import Usage from "./Usage";
import NewArtist from "./NewArtist";
import PageAppBar from "./PageAppBar";
import ConsoleTabs from "./ConsoleTabs";
import { useSearchParams } from "react-router-dom";

export default function Console() {
  const searchParams = useSearchParams()[0];
  const view = searchParams.get("view");

  return (
    <Box>
      <PageAppBar />
      <ConsoleTabs />
      <Box sx={{ pl: "150px", py: 10 }}>
        {view === "songs" ? (
          <Songs />
        ) : view === "new-artist" ? (
          <NewArtist />
        ) : (
          <Usage />
        )}
      </Box>
    </Box>
  );
}
